// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"435":"f7545296","844":"c6dba71d"}[chunkId] + ".chunk.css";
};